import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import IconSearch from "../icons/IconSearch";
import { Container, Button, Input, Bar } from "./styled/stream-cards-search";

class StreamCardsSearch extends Component {
  inputRef = createRef();

  state = {
    focusInput: false,
    value: this.props.searchTerm || ""
  };

  render() {
    return (
      <Container
        data-testid="streams-search-form"
        hasValue={!!this.state.value}
        onSubmit={this.handleOnSubmit}>
        <Button type="button" onClick={this.handleOnClick}>
          <IconSearch />
        </Button>
        <Input
          data-testid="streams-search-input"
          ref={this.inputRef}
          value={this.state.value}
          placeholder="Search Streams"
          onChange={this.handleOnChange}
          onBlur={this.handleOnBlur}
        />
        <Bar />
      </Container>
    );
  }

  componentDidUpdate() {
    if (this.state.focusInput) {
      this.inputRef.current.focus();
    }
  }

  handleOnSubmit = (e) => {
    e.preventDefault();

    this.props.searchStreams({ searchTerm: this.state.value });
  };

  handleOnClick = () => {
    this.setState({ focusInput: true });
  };

  handleOnBlur = () => {
    this.setState({ focusInput: false });
  };

  handleOnChange = (e) => {
    this.setState({ value: e.target.value });
  };
}

StreamCardsSearch.propTypes = {
  searchTerm: PropTypes.string,
  searchStreams: PropTypes.func.isRequired
};

export default StreamCardsSearch;
